/**
 * Hard ceiling of participants per competition (single source of truth for
 * API, schemas and mobile).
 */
export const MAX_PARTICIPANTS_PER_COMPETITION = 2048;
